import script from "./TermsAndConditionsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./TermsAndConditionsView.vue?vue&type=script&lang=ts&setup=true"

import "./TermsAndConditionsView.vue?vue&type=style&index=0&id=375d5f4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-375d5f4c"]])

export default __exports__